export enum AttributionType {
  USER = 'user',
  PROMO = 'promo',
  CAMPAIGN = 'campaign',
  AFFILIATE = 'affiliate',
}
